export const CANVAS_WIDTH = 1080;//500;
export const CANVAS_HEIGHT = 2220;//1500;

const createCanvas = (bg = '#EDEDED', w = CANVAS_WIDTH, h = CANVAS_HEIGHT) => {
	const canvas = document.createElement('canvas');
	canvas.width = w;
	canvas.height = h;
	canvas.fillStyle = bg;
	canvas.getContext('2d').fillRect(0, 0, w, h);
	return canvas;
};

const fit = contains => {
	return (parentWidth, parentHeight, childWidth, childHeight, scale = 1, offsetX = 0.5, offsetY = 0.5) => {
		const childRatio = childWidth / childHeight;
		const parentRatio = parentWidth / parentHeight;
		let width = parentWidth * scale;
		let height = parentHeight * scale;
		if (contains ? (childRatio > parentRatio) : (childRatio < parentRatio)) {
			height = width / childRatio;
		} else {
			width = height * childRatio;
		}
		return {
			width,
			height,
			offsetX: (parentWidth - width) * offsetX,
			offsetY: (parentHeight - height) * offsetY
		}
	}
};

const contain = fit(true);

const cover = fit(false);

const getLines = (ctx, text, maxWidth) => {
	let words = text.split(" ");
	let lines = [];
	let currentLine = words[0];
	for (let i = 1; i < words.length; i++) {
		let word = words[i];
		let width = ctx.measureText(currentLine + " " + word).width;
		if (width < maxWidth) {
			currentLine += " " + word;
		} else {
			lines.push(currentLine);
			currentLine = word;
		}
	}
	lines.push(currentLine);
	return lines;
};

const createBlobFromCanvas = canvas => {
	let dataURL = canvas.toDataURL();
	let bytes = atob(dataURL.split(',')[1]);
	let arr = new Uint8Array(bytes.length);
	for(var i = 0; i < bytes.length; i++){
		arr[i] = bytes.charCodeAt(i);
	}
	return new Blob([arr], {type:'image/png'});
};

export const drawFurge01 = data => {
	const {
		realImage,
		logo,
		header,
		title,
		subtitle,
		bg,
	} = data;
	const w = CANVAS_WIDTH;
	const h = CANVAS_HEIGHT;
	const canvas = createCanvas(bg, w, h);
	const ctx = canvas.getContext('2d');
	const mh = h * .6;
	const sh = mh - 84;
	const th = sh - 60;
	const hh = th - 50;
	const clear = (all) => {

	};
	ctx.fillStyle = bg;
	ctx.fillRect(0, 0, w, h);
	if (realImage) {
		const {
			offsetX,
			offsetY,
			width,
			height,
		} = cover(w, hh - 40, realImage.width, realImage.height);
		ctx.drawImage(realImage, offsetX, offsetY, width, height);
	}
	ctx.fillRect(0, hh - 40, w, h);
	ctx.fillStyle = '#F8981F';
	ctx.shadowColor = 'rgba(0,0,0,0.4)';
	ctx.shadowBlur = 40;
	ctx.shadowOffsetX = 0;
	ctx.shadowOffsetY = 20;
	ctx.strokeStyle = '#fff';
	ctx.lineWidth = 4;
	ctx.fillRect(0, mh - 46, w, 92);
	ctx.shadowColor = 'rgba(0,0,0,0)';
	ctx.strokeRect(-20, mh - 46, w + 20, 92);
	ctx.font = 'bold 52px Montserrat';
	ctx.fillStyle = '#fff';
	ctx.textBaseline = 'middle';
	ctx.textAlign = 'center';
	ctx.fillText('Érdekel a munka?', w / 2, mh);
	ctx.fillStyle = '#fff';
	ctx.shadowColor = 'rgba(0,0,0,0.6)';
	ctx.shadowBlur = 2;
	ctx.shadowOffsetX = 2;
	ctx.shadowOffsetY = 2;
	ctx.textBaseline = 'middle';
	ctx.textAlign = 'center';
	let fs = 32;
	do {
		ctx.font = `bold ${fs}px Montserrat`;
		fs -= .5;
	} while (ctx.measureText(header.toUpperCase()).width > w - 40);
	ctx.fillText(header.toUpperCase(), w / 2, hh);
	ctx.fillStyle = '#F8981F';
	fs = 44;
	do {
		ctx.font = `bold ${fs}px Montserrat`;
		fs -= .5;
	} while (ctx.measureText(subtitle).width > w - 40);
	ctx.fillText(subtitle, w / 2, sh);
	fs = 60;
	do {
		ctx.font = `bold ${fs}px Montserrat`;
		fs -= .5;
	} while (ctx.measureText(title).width > w - 40);
	ctx.fillStyle = '#fff';
	ctx.fillText(title, w / 2, th);
	if (logo) {
		const lr = contain(w * .5, h * .1, logo.width, logo.height);
		const lx = w - (lr.width + 40);
		const ly = 20;
		ctx.drawImage(logo, 0, 0, logo.width, logo.height, lx, ly, lr.width, lr.height);
	}
	console.log(
		`=== FURGE ===`,
		`Background: ${w}x${hh}`,
	);
	return createBlobFromCanvas(canvas);
};


export const drawFurge02 = data => {
	const { realImage, message } = data;
	const w = CANVAS_WIDTH;
	const h = CANVAS_HEIGHT;
	const canvas = createCanvas('#EDEDED', w, h);
	const ctx = canvas.getContext('2d');
	realImage && ctx.drawImage(realImage, 0, 0, realImage.width, realImage.height, 0, 0, w, h);
	ctx.font = 'bold 30px Montserrat';
	ctx.textBaseline = 'middle';
	ctx.textAlign = 'left';
	ctx.translate(w / 2, (h - 150) / 2);
	ctx.rotate(-2 * (Math.PI / 180));
	ctx.translate(-w / 2, -(h - 150) / 2);
	const lines = getLines(ctx, message, w - 140);
	const startY = ((h - 150) / 2) - ((lines.length * 35) / 2);
	ctx.fillStyle = '#ffffff';
	ctx.fillRect(-100, startY - 50, w + 200, lines.length * 35 + 50);
	ctx.fillStyle = '#454545';
	lines.forEach((line, i) => {
		ctx.fillText(line, 70, startY + (i * 35));
	});
	ctx.translate(w / 2, (h - 150) / 2);
	ctx.rotate(2 * (Math.PI / 180));
	ctx.translate(-w / 2, -(h - 150) / 2);
	console.log(
		`=== FURGE02 ===`,
		`Background: ${w}x${h}`,
	);
	return createBlobFromCanvas(canvas);
}

export const drawSeyu1 = data => {
	const { realBackground, realLogo, title, message, colors } = data;
	const canvas = createCanvas('#EDEDED');
	const ctx = canvas.getContext('2d');
	const w = CANVAS_WIDTH;
	const h = CANVAS_HEIGHT;
	const bgGradient = ctx.createLinearGradient(0, 0, 0, h);
	bgGradient.addColorStop(0, '#D70A0A');
	bgGradient.addColorStop(.45, '#BA9585');;
	bgGradient.addColorStop(.55, '#879577');;
	bgGradient.addColorStop(1, '#044505');;
	ctx.fillStyle = bgGradient;
	ctx.fillRect(0, 0, w, h);
	ctx.shadowColor = '#00000000';
	ctx.shadowBlur = 20;
	ctx.shadowOffsetX = 0;
	ctx.shadowOffsetY = 5;
	realBackground && ctx.drawImage(realBackground, 0, 0, realBackground.width, realBackground.height, 0, 0, w, h);
	ctx.font = 'bold 60px Montserrat';
	ctx.textBaseline = 'top';
	ctx.textAlign = 'center';
	const lines = getLines(ctx, message, w - 40);
	let startY = 655;
	ctx.fillStyle = '#ffffff';
	ctx.shadowColor = '#000000';
	ctx.fillRect(-100, startY - 50, w + 200, lines.length * 70 + 100);
	ctx.fillStyle = '#D70A0A';
	ctx.shadowColor = '#00000000';
	ctx.fillRect(-100, startY - 60, w + 200, 10);
	ctx.fillRect(-100, startY - 50 + (lines.length * 70 + 100), w + 200, 10);
	ctx.fillStyle = colors.message;
	lines.forEach((line, i) => {
		ctx.fillText(line, w / 2, startY + (i * 70));
	});
	const startY2 = startY - 50 + (lines.length * 70 + 100) + 100;
	ctx.font = 'bold 80px Montserrat';
	ctx.fillStyle = '#ffffff';
	ctx.shadowColor = '#000000';
	ctx.fillRect(-100, startY2 - 50, w + 200, 140);
	ctx.fillStyle = '#D70A0A';
	ctx.shadowColor = '#00000000';
	ctx.fillRect(-100, startY2 - 60, w + 200, 10);
	ctx.fillRect(-100, startY2 + 90, w + 200, 10);
	ctx.fillStyle = colors.title;
	ctx.fillText(title, w / 2, startY2 - 10);
	if (realLogo) {
		const lr = contain(w, startY - 100, realLogo.width, realLogo.height);
		ctx.drawImage(realLogo, 0, 0, realLogo.width, realLogo.height, 0, 0, w, startY - 100);
	}
	console.log(
		`=== SEYU1 ===`,
		`Background: ${w}x${h}`,
		`Logo: ${w - 40}x${startY - 100}`,
	);
	return createBlobFromCanvas(canvas);
};

export const drawSeyu2 = data => {
	const { realBackground, realLogo, question } = data;
	const canvas = createCanvas('#D70A0A');
	const ctx = canvas.getContext('2d');
	const w = CANVAS_WIDTH;
	const h = CANVAS_HEIGHT;
	const bgGradient = ctx.createLinearGradient(0, 0, 0, h);
	bgGradient.addColorStop(0, '#D70A0A');
	bgGradient.addColorStop(.45, '#BA9585');;
	bgGradient.addColorStop(.55, '#879577');;
	bgGradient.addColorStop(1, '#044505');;
	ctx.fillStyle = bgGradient;
	ctx.fillRect(0, 0, w, h);
	realBackground && ctx.drawImage(realBackground, 0, 0, realBackground.width, realBackground.height, 0, 0, w, h);
	/*
	ctx.font = 'bold 60px Montserrat';
	ctx.textBaseline = 'top';
	ctx.textAlign = 'center';
	const lines = getLines(ctx, question, w - 80);
	let startY = h * .22;
	ctx.fillStyle = '#ffffff';
	ctx.shadowColor = '#000000';
	ctx.shadowBlur = 20;
	ctx.shadowOffsetX = 0;
	ctx.shadowOffsetY = 5;
	ctx.fillRect(20, startY, w - 40, lines.length * 70 + 40);
	ctx.shadowColor = '#00000000';
	ctx.fillStyle = '#00A551';
	lines.forEach((line, i) => {
		ctx.fillText(line, w / 2, startY + (i * 70) + 20);
	});
	*/
	if (realLogo) {
		const lr = contain(w, 330, realLogo.width, realLogo.height);
		ctx.drawImage(realLogo, 0, 0, realLogo.width, realLogo.height, 0, 0, w, 330);
	}
	console.log(
		`=== SEYU2 ===`,
		`Background: ${w}x${h}`,
		`Logo: ${w}x330`,
	);
	return createBlobFromCanvas(canvas);
};
